/**
 * @class UITimelimit
 * @classdesc Класс для работы с таймером обратного отсчета
 *
 * @param {Object} options - Объект с настройками таймера
 * @param {jQuery} options.$wrapper - jQuery-объект элемента-контейнера для таймера
 * @param {Number|String} options.timelimit - Лимит времени в секундах (целое число)
 * @param {Boolean} [options.no_units=false] - Флаг, указывающий нужно ли скрывать единицы измерения времени
 * @param {Boolean} [options.custom_html=false] - Флаг, указывающий используется ли кастомная HTML-разметка
 * @param {Function} [options.onTimeLeft=function(){}] - Callback-функция, вызываемая при изменении оставшегося времени
 *
 * @throws Вызывает ошибку через $.sa.error() если не переданы обязательные параметры или некорректный timelimit
 */
class UITimelimit {
    custom_events = {
        time_ended: 'timelimit_time_ended'
    };

    class_names = {
        day   : 'js-timelimit-day',
        hour  : 'js-timelimit-hour',
        minute: 'js-timelimit-minute',
        second: 'js-timelimit-second'
    };

    constructor(options = {}) {
        const that = this;

        if (!options.hasOwnProperty('$wrapper') || !options.hasOwnProperty('timelimit')) {
            $.sa.error('UITimelimit: invalid init options.');
            return;
        }

        that.no_units = (typeof options['no_units'] === 'boolean' ? options['no_units'] : false);
        that.custom_html = (typeof options['custom_html'] === 'boolean' ? options['custom_html'] : false);

        // DOM
        that.$wrapper = options['$wrapper'];

        // CONST
        that.start_time = Date.now();
        that.duration = Number.isInteger(options['timelimit'])
            ? options['timelimit']
            : (parseInt(options['timelimit'], 10) || 0);

        if (that.duration < 0) {
            $.sa.error(`UITimelimit: invalid time limit had been passed: "${options['timelimit']}"`);
            return;
        } else if (that.duration === 0) {
            $.sa.log('UITimelimit: time limit is 0 or empty, timer would not tick.');
            return;
        }

        that.onTimeLeft = (typeof options['onTimeLeft'] === 'function' ? options['onTimeLeft'] : function () {});

        // DYNAMIC VARS
        that.timeout = 0;

        // INIT
        that.start();
    }

    start() {
        const that = this;
        that.tick();
    }

    clear() {
        const that = this;
        clearTimeout(that.timeout);
    }

    tick() {
        const that = this;

        const is_exist = that.$wrapper.length && document.contains(that.$wrapper[0]);
        if (!is_exist) { return false; }

        const now = Date.now();

        // to resolve problem with stopping timer by browser (see SMA-4505)
        let time_past = now - that.start_time;
        time_past = Math.floor(time_past/1000); // В секундах

        let time_left = that.duration - time_past;
        time_left = (time_left < 0 ? 0 : time_left);

        const d = Math.floor(time_left / 60 / 60 / 24),
            h = Math.floor((time_left - d * 24 * 60 * 60) / 60 / 60),
            m = Math.floor((time_left - d * 24 * 60 * 60 - h * 60 * 60) / 60),
            s = time_left - d * 24 * 60 * 60 - h * 60 * 60 - m * 60;

        that.#render({ d: d, h: h, m: m, s: s });

        if (time_left > 0) {
            that.timeout = setTimeout(function () {
                that.tick();
            }, 1000);
        } else {
            that.$wrapper.trigger(that.custom_events.time_ended);
            that.onTimeLeft(that.$wrapper, that);
        }
    }

    /**
     * @param {Object} time
     */
    #render(time) {
        const that = this;

        if (that.custom_html) {
            that.#renderHtml(time);
        } else {
            const time_text = that.#getTimeText(time);
            that.$wrapper.text(time_text);
        }
    }

    #renderHtml(time) {
        const that = this;

        const $day    = that.$wrapper.find('.' + that.class_names.day),
              $hour   = that.$wrapper.find('.' + that.class_names.hour),
              $minute = that.$wrapper.find('.' + that.class_names.minute),
              $second = that.$wrapper.find('.' + that.class_names.second);

        if ($day.length) {
            const text = getText(time['d']);
            $day.text(text);
        }

        if ($hour.length) {
            const text = getText(time['h']);
            $hour.text(text);
        }

        if ($minute.length) {
            const text = getText(time['m']);
            $minute.text(text);
        }

        if ($second.length) {
            const text = getText(time['s']);
            $second.text(text);
        }

        /**
         * @param {Number?} value
         * @returns {String}
         * */
        function getText(value) {
            let result = '00';

            if (value > 0) {
                result = (value < 10 ? '0' : '') + value;
            }

            return result;
        }
    }

    /**
     * @param {Object} time
     * @returns {String}
     */
    #getTimeText(time) {
        const that = this;

        let locale_strings = $.sa.locales.timelimit;
        if (that.no_units === true) {
            locale_strings = {
                'd': '%d:%h:%m:%s',
                'h': '%h:%m:%s',
                'm': '%m:%s',
                's': '%s'
            }
        }

        if (time['d'] && time['d'] > 0) {
            return locale_strings['d']
                .replace('%d', ((time['d'] < 10) ? '0' : '') + time['d'].toString())
                .replace('%h', ((time['h'] < 10) ? '0' : '') + time['h'].toString())
                .replace('%m', ((time['m'] < 10) ? '0' : '') + time['m'].toString())
                .replace('%s', ((time['s'] < 10) ? '0' : '') + time['s'].toString());
        }

        if (time['h'] && time['h'] > 0) {
            return locale_strings['h']
                .replace('%h', ((time['h'] < 10) ? '0' : '') + time['h'].toString())
                .replace('%m', ((time['m'] < 10) ? '0' : '') + time['m'].toString())
                .replace('%s', ((time['s'] < 10) ? '0' : '') + time['s'].toString());
        }

        return locale_strings['m']
            .replace('%m', ((time['m'] < 10) ? '0' : '') + time['m'].toString())
            .replace('%s', ((time['s'] < 10) ? '0' : '') + time['s'].toString());
    }
}